import * as React from 'react';
import AssetModelListDesktop from './AssetModelListDesktop';


const AssetModelListMobile = () => {

    return (<AssetModelListDesktop/>)
}

export default AssetModelListMobile;